export const ERROR_TYPE = Object.freeze({
    QTY: "tooltip.error_type.qty",
    QTY_TW: "tooltip.error_type.qty_tw",
    QTY_MISMATCH_MIN_MAX_INC: "tooltip.error_type.qty_mismatch_min_max_inc",
    QTY_MISMATCH_COLLATERAL: "tooltip.error_type.qty_mismatch_collateral",
    QTY_MISMATCH_CURRENCY: "tooltip.error_type.qty_mismatch_currency",
    QTY_COMPARE_CONFIRM: "tooltip.error_type.qty_compare_confirm",
    QTY_COMPARE_ORIGIN: "tooltip.error_type.qty_compare_origin",
    QTY_COMPARE_REQ: "tooltip.error_type.qty_compare_req",
    QTY_COMPARE_OFFER: "tooltip.error_type.qty_compare_offer",
    QTY_EXCEEDS_DYNAMIC_LIST_INVENTORY:
        "tooltip.error_type.qty_exceeds_dynamic_list_inventory",
    VALUE_DATE_MISMATCH: "tooltip.error_type.value_date_mismatch",
    MATURITY_DATE_MISMATCH: "tooltip.error_type.maturity_date_mismatch",
    DIVIDEND_EXCEEDS_REQUESTED: "tooltip.error_type.dividend_exceeds_requested",
    DIVIDEND_NOT_EXACT_MATCH: "tooltip.error_type.dividend_not_exact_match",
    CALLABLE_INCOMPATIBLE: "tooltip.error_type.callable_incompatible",
    COMBINED_QTY_EXCEEDS_DYNAMIC_LIST_INVENTORY:
        "tooltip.error_type.combined_qty_exceeds_dynamic_list_inventory",
    RATE: "tooltip.error_type.rate",
    RATE_COMPARE_OFFER: "tooltip.error_type.rate_compare_offer",
    RATE_TOO_HIGH: "tooltip.error_type.rate_too_high",
    RATE_TOO_LOW: "tooltip.error_type.rate_too_low",
    DIV: "tooltip.error_type.div",
    VALUE_DATE: "tooltip.error_type.value_date",
    BAD_VALUE_DATE: "tooltip.error_type.bad_value_date",
    MATURITY: "tooltip.error_type.maturity",
    MATURITY_MAX_EXCEED: "tooltip.error_type.maturity_max_exceed",
    LISTNAME: "tooltip.error.listname",
    SPLIT_NOT_ALLOWED: "tooltip.error.split_not_allowed",
    SPLIT_MAXED_OUT: "tooltip.error.split_maxed_out",
});
